import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/disciplinary-actions', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const store = data => {
    return httpClient
        .post('/api/disciplinary-actions', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const find = (id, Options = {}) => {
    return httpClient
        .get(`/api/disciplinary-actions/${id}`, Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const disciplinarySubject = (options = {}) => {
    return httpClient
        .get('/api/disciplinary-actions/disciplinary-subjects', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const subjectType = (options = {}) => {
    return httpClient
        .get('/api/disciplinary-actions/subject-types', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const previewPdf = (Options = {}) => {
    return httpClient
        .get('/api/disciplinary-actions/preview-pdf', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default {
    get,
    store,
    find,
    disciplinarySubject,
    subjectType,
    previewPdf
}
